<script>
	import { writable } from 'svelte/store'
  import RadarMarker from '../components/RadarMarker.svelte';
	import { onMount, onDestroy, getContext } from "svelte";
	import { addOverlay, globalOverlay, removeOverlay, getMap } from "../map";


	let globalFeed = getContext("GlobalFeed");

	const trackStore = writable({})
	let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("Radar", layer, globalOverlay);
		layer.addTo(getMap())

		globalFeed.addEventListener("RADAR_TRACK", onRadarTrack)
		globalFeed.addEventListener("RADAR_TRACK_END", onRadarTrackEnd)
	});
	onDestroy(() => {
		removeOverlay(layer, globalOverlay)
		layer.removeFrom(getMap())

		globalFeed.removeEventListener("RADAR_TRACK", onRadarTrack)
		globalFeed.removeEventListener("RADAR_TRACK_END", onRadarTrackEnd)
	})

	trackStore.subscribe(t => {
		window.radar = t
	})

	function onRadarTrack(event) {
		trackStore.update(s => {
			s[event.detail.trackNumber] = event.detail
			clearTimeout(s[event.detail.trackNumber].timeout)
			return s
		})
	}
	function onRadarTrackEnd(event) {
		trackStore.update(s => {
			if (!s[event.detail.trackNumber]) return s

			s[event.detail.trackNumber].deleted = true
			clearTimeout(s[event.detail.trackNumber].timeout)
			s[event.detail.trackNumber].timeout = setTimeout(() => deleteTrack(event.detail.trackNumber), 5 * 1000)
			return s
		})		
	}
	function deleteTrack(trackNumber) {
		trackStore.update(s => {
				delete s[trackNumber]
				return s
			})	
	}
</script>

{#each Object.values($trackStore) as info}
	<RadarMarker {info} {layer} />
{/each}